import { create } from "zustand";

interface PosTokenStore {
  isDeletingPosToken: boolean;
  setIsDeletingPosToken: (isDeleting: boolean) => void;
}

export const usePosTokenStore = create<PosTokenStore>((set) => ({
  isDeletingPosToken: false,
  setIsDeletingPosToken: (isDeleting) =>
    set({ isDeletingPosToken: isDeleting }),
}));
